import React, { useEffect, useState } from "react";

export default function Toggle({ onToggle, active }) {
  const [isActive, setIsActive] = useState(active);

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  function toggle() {
    const active = !isActive;
    setIsActive(active);
    onToggle(active);
  }

  return (
    <div
      className={`w-12 h-[30px] rounded-[15px] transition-colors cursor-pointer ${
        isActive ? "bg-[#dd8835]" : "bg-[#adadad]"
      }`}
      onClick={() => toggle()}
    >
      <div
        className={`w-6 h-6 rounded-full mt-[3px] bg-white transition-all duration-250 ease-[cubic-bezier(0.175,0.885,0.320,1.225)] ${
          isActive ? "ml-[21px]" : "ml-[3px]"
        }`}
      ></div>
    </div>
  );
}

